export const allStars = 5;